const TOKEN_KEY = 'jwt'

const getLocalRefreshToken = () => {
  return getJWT()?.refreshToken
}

const getLocalAccessToken = () => {
  return getJWT()?.accessToken
}

const updateLocalAccessToken = (token) => {
  const jwt = getJWT()
  jwt.accessToken = token
  setJWT(jwt)
}

const getJWT = () => {
  return JSON.parse(localStorage.getItem(TOKEN_KEY))
}

const setJWT = (jwt) => {
  if (!jwt) {
    return
  }
  localStorage.setItem(TOKEN_KEY, JSON.stringify(jwt))
}

const removeJWT = () => {
  localStorage.removeItem(TOKEN_KEY)
}

const TokenService = {
  getLocalRefreshToken,
  getLocalAccessToken,
  updateLocalAccessToken,
  getJWT,
  setJWT,
  removeJWT,
}
export default TokenService
